/**
 * Hub AI page context (same idea as ATW One AI's pageContext): one table drives the panel's
 * "On …" line, its starter chips, and the module hint sent to the API.
 */
export type HubAiPageContext = {
  module: string;
  label: string;
  suggestions: string[];
};

const RULES: { test: RegExp; context: HubAiPageContext }[] = [
  {
    test: /^\/meetings/,
    context: {
      module: "meetings",
      label: "Meetings",
      suggestions: ["Prep me for my next meeting", "What follow-ups do I owe from today's meetings?", "Which meetings this week need prep?"],
    },
  },
  {
    test: /^\/tasks/,
    context: {
      module: "tasks",
      label: "Tasks",
      suggestions: ["Plan my day around my meetings", "What's overdue?", "Turn my unread mail into tasks"],
    },
  },
  {
    test: /^\/calendar/,
    context: {
      module: "calendar",
      label: "Calendar",
      suggestions: ["What does tomorrow look like?", "Find time I'm free this week", "Prep me for my next meeting"],
    },
  },
  {
    test: /^\/mail/,
    context: {
      module: "mail",
      label: "Mail",
      suggestions: ["What needs my reply?", "Turn my unread mail into tasks", "Summarize mail about my next meeting"],
    },
  },
  {
    test: /^\/chat/,
    context: {
      module: "chat",
      label: "Chat",
      suggestions: ["What needs my reply in Slack?", "Catch me up on today", "Turn Slack asks into tasks"],
    },
  },
  {
    test: /^\/settings/,
    context: { module: "settings", label: "Settings", suggestions: ["What can Hub AI do?", "Plan my day"] },
  },
];

const HOME: HubAiPageContext = {
  module: "hub",
  label: "Home",
  suggestions: ["Plan my day", "Prep me for my next meeting", "What's overdue?"],
};

export function resolveHubAiContext(pathname: string): HubAiPageContext {
  return RULES.find((rule) => rule.test.test(pathname))?.context ?? HOME;
}
